import { z } from "zod";

export const DataSourceImportModel = z.object({
  id: z.string(),
  fileName: z.string().optional(),
  thumbnailUrl: z.string().optional(),
});

export type DataSourceImportModel = z.infer<typeof DataSourceImportModel>;
